import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import OliverText from "@builder/components/general/OliverText";
import SelectInput from "@builder/components/general/SelectInput";
import { getFilterTargets, getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { FilterNode } from "@common/build/types";

const FilterTarget = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as FilterNode;

    const filterTargetOptions = useAppSelector(getFilterTargets);
    const filterTarget = node.filter?.target;
    const filterTargetCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["filter", "target"], value }));
    };

    return (
        <SidebarCollapse title="Target" parent={parent}>
            <OliverText
                text="Set filter target"
                size="xs"
                style={{ marginBottom: "-8px" }}
                translatePrefix="editable.filterTarget."
            />
            <OliverText
                text="This will update the grid query whenever filter is in use."
                size="xxs"
                translatePrefix="editable.filterTarget."
            />
            <SelectInput layout="column" value={filterTarget} options={filterTargetOptions} callback={filterTargetCallback} noTranslate />
        </SidebarCollapse>
    );
};

export default FilterTarget;
